"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _SenderGiftLanguage = _interopRequireDefault(require("../../containers/SenderGiftLanguage/SenderGiftLanguage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    avatar: {
      backgroundColor: palette.error.main,
      width: 46,
      height: 46,
      marginRight: spacing(2)
    },
    icon: {
      color: 'white'
    },
    root: {
      width: '420px',
      borderTop: "4px solid ".concat(palette.error.main)
    },
    cancelButton: {
      backgroundColor: 'transparent',
      color: palette.grey.main,
      border: "1px solid ".concat(palette.divider),
      boxShadow: 'none',
      marginRight: spacing(2),
      height: '48px',
      padding: spacing(1, 4),
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    submitButton: {
      backgroundColor: palette.error.main,
      color: 'white',
      boxShadow: 'none',
      height: '48px',
      padding: spacing(1, 4),
      '&:hover': {
        backgroundColor: palette.error.dark
      }
    },
    actions: {
      padding: spacing(2)
    }
  };
});

var Transition = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_material.Slide, (0, _extends2.default)({
    direction: "up",
    ref: ref
  }, props));
});

var DiscardGiftConfirmation = function DiscardGiftConfirmation(_ref2) {
  var isOpen = _ref2.isOpen,
      recipientName = _ref2.recipientName,
      onCancel = _ref2.onCancel,
      onSubmit = _ref2.onSubmit,
      width = _ref2.width,
      top = _ref2.top;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    TransitionComponent: Transition,
    style: {
      width,
      left: 'initial'
    },
    BackdropProps: {
      style: {
        top,
        width,
        left: 'initial',
        background: 'white',
        opacity: 0.8
      }
    },
    PaperProps: {
      elevation: 1,
      square: false,
      classes: {
        root: classes.root
      }
    },
    disablePortal: true,
    open: isOpen
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.avatar
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    className: classes.icon,
    icon: "trash-alt"
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H3-Dark"
  }, "Discard ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " ?"))), /*#__PURE__*/_react.default.createElement(_material.DialogContent, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "By doing so, you\u2019ll permanently lose all of your progress on this ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), ". ", recipientName, "\u2019s information and research will still be saved though!")), /*#__PURE__*/_react.default.createElement(_material.DialogActions, {
    className: classes.actions
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    className: classes.cancelButton,
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    className: classes.submitButton,
    autoFocus: true,
    onClick: onSubmit
  }, /*#__PURE__*/_react.default.createElement("span", null, "Discard ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null)))));
};

DiscardGiftConfirmation.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  recipientName: _propTypes.default.string.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  width: _propTypes.default.string,
  top: _propTypes.default.string
};
DiscardGiftConfirmation.defaultProps = {
  width: '600px',
  top: '129px'
};
var _default = DiscardGiftConfirmation;
exports.default = _default;